// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-title[data-v-1545129f]{padding-top:20px}.items[data-v-1545129f]{display:grid;grid-gap:20px;gap:20px;grid-template-columns:repeat(auto-fill,minmax(140px,1fr))}.items .item[data-v-1545129f]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.items .item img[data-v-1545129f]{height:100%;-o-object-fit:contain;object-fit:contain;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
